import { store } from 'src/redux/store';
import pConfig from 'pConfig';

export default function setBooheeSeeConfig() {
  const { token } = store.getState();

  const config = Object.assign(window.$BooheeSeeConfig || {}, {
    url: pConfig.REPORT_URL,
    env: API_ENV === 'production' ? 'prod' : 'rc',
    appId: 'truck',
    bizUserId: token,
    debug: false,
    sampleResoucreRate: 0.6,
    samplePerformanceRate: 0.6,
    apiIgnoreList: [
      {
        pattern: 'open-interface/v1/data/(report_distinct|report_data)',
        mode: 'regex'
      }
    ],
    resourceIgnoreList: [
      {
        pattern: 'pixiu/intestinal-health',
        mode: 'regex'
      },
      {
        pattern: /(house)\/.*?\.(png|jpeg|jpg|woff2|otf|ttf|woff)/i, // 忽略图片/字体资源
        mode: 'regex'
      },
      {
        pattern: /(bj\.boohee\.cn|one\.boohee\.cn|up\.boohee\.cn)/,
        mode: 'regex'
      }
    ]
  });

  window.$BooheeSeeConfig = config;
}
